const stats = [
  { value: "350+", label: "Dni słonecznych rocznie", color: "text-orange-500" },
  { value: "25°C", label: "Średnia temperatura", color: "text-teal-500" },
  { value: "50+", label: "Obiektów sportowych", color: "text-orange-500" },
  { value: "1000+", label: "Zrealizowanych obozów", color: "text-teal-500" },
];

export default function PlayitasHero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pb-48">
      <div className="absolute inset-0">
        <img src="https://api.playitas.net/sites/default/files/2023-06/Playitas_Resort_00.JPG"
          alt="Playitas Resort" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full pt-20">
        <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full mb-8">
          <span className="text-white text-sm font-medium tracking-wider">// NAJLEPSZY RESORT SPORTOWY W EUROPIE</span>
        </div>
        <h1 className="text-6xl md:text-8xl font-black mb-6 leading-tight">
          <div className="text-white">ORGANIZUJ SWÓJ</div>
          <div className="text-yellow-400 drop-shadow-lg">TRAINING CAMP</div>
          <div className="text-white">W RAJU</div>
        </h1>
        <p className="text-white/90 text-xl mb-12 max-w-3xl mx-auto leading-relaxed">
          Dołącz do najlepszych trenerów fitness, CrossFit i Hyrox, którzy ufają Playitas Resort
          w organizacji swoich profesjonalnych obozów treningowych
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-20">
          <button onClick={() => scrollTo("#facilities")}
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full font-bold text-lg transition-all cursor-pointer whitespace-nowrap flex items-center gap-3 shadow-xl">
            ODKRYJ OBIEKTY <i className="ri-arrow-right-line" />
          </button>
          <a href="https://www.playitas.net" target="_blank" rel="noopener noreferrer"
            className="border-2 border-white bg-transparent hover:bg-white/10 text-white px-8 py-4 rounded-full font-bold text-lg transition-all cursor-pointer whitespace-nowrap flex items-center gap-3">
            <i className="ri-external-link-line" /> STRONA GŁÓWNA PLAYITAS
          </a>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 w-full max-w-5xl px-6 z-20">
        <div className="bg-white rounded-3xl shadow-2xl p-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <div key={s.label} className={`text-center ${i > 0 ? "border-l border-gray-200" : ""}`}>
              <div className={`text-4xl font-black mb-2 ${s.color}`}>{s.value}</div>
              <div className="text-sm text-gray-600">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
